export const initialData = {
  init: false,
  fields: {
    AssignedFirmID: null,
    Transaction: '',
    Description: '',
    Date: '',
  },
};
